import { OrganizationSubscriptionResponseType } from 'src/models/OrganizationSubscription';
import { httpGet } from 'src/utils/http';

const path = '/organizationsubscription';

export const apiGetTrialStatus = (organizationPermanentUrl: string): Promise<OrganizationSubscriptionResponseType> =>
  httpGet(`${path}/gettrialsubscriptionstatusforcurrentuser`, {
    organizationPermanentUrl,
  });
